<template lang="pug">
  router-view(v-if='hasAccess')
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      hasAccess: false
    };
  },
  computed: {
    ...mapGetters("auth", ["isActiveCompanyAdmin", "isSuperUser"])
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.isActiveCompanyAdmin && !vm.isSuperUser) {
        vm.$msgbox({
          type: "error",
          title: "Unauthorised",
          message: "You are not allowed to access this section."
        }).then(() => {
          next({ name: "login" });
        });
        return;
      }
      vm.hasAccess = true; /* eslint no-param-reassign: 0 */
      next();
    });
  }
};
</script>
